import { AIButtonContainedGrey } from '../../AIButton'

function AISelectControlContainer({
  Button = AIButtonContainedGrey,
  Icon,
  defaultValue,
  placeholder,
  ref,
  value,
  onClick,
  ...buttonProps
}) {
  const displayLabel =
    defaultValue && value?.value === defaultValue.value ? null : value?.label

  const ActiveIcon = value?.Icon || Icon

  return (
    <div ref={ref} onClick={onClick}>
      <Button
        {...buttonProps}
        beforeIconProps={{ Icon: ActiveIcon }}
        text={displayLabel || placeholder}
      />
    </div>
  )
}

export default AISelectControlContainer
